import { FC, useCallback, useContext, useEffect, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import { useRouter } from "next/router";
import { NavType } from "../../navbar";
import cName from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { IndexContext } from "@/stores";
import classNames from "classnames";
import { Breadcrumb } from "@douyinfe/semi-ui";
import searchNode from "@/utils/searchNode";
import { useTranslations } from "next-intl";


type CrumbType = {
  path: string,
  name: string,
}

export interface ILayoutProps {
  crumb?: CrumbType[],
  banner?: string;
  partPath?: string | undefined | null;
}

const getMenuCurrent = (menu: any[], path: string): any => {
  for (let i = 0; i < menu?.length; i++) {
    const item = menu[i];
    if (item.path === path) {
      return item;
    }

    if (item.childlist && Array.isArray(item.childlist)) {
      const child = getMenuCurrent(item.childlist, path) as any;
      if (child) {
        return child;
      }
    }
  }

  return null;
}

export const PageCrumb: FC<ILayoutProps> = ({
  crumb = [],
  banner = '/image/page-banner.png',
  partPath
}) => {
  const { menuList } = useContext(IndexContext)
  const router = useRouter()
  const [isVideo, setIsVideo] = useState(false)
  const t = useTranslations();

  const [menuParent, setMenuParent] = useState<any>()
  const [menuCurrent, setMenuCurrent] = useState<any>()

  useEffect(() => {
    const current = getMenuCurrent(menuList, partPath || router.asPath)
    setMenuCurrent(current)
    const parent = menuList?.find(item => item.id === current?.pid)
    setMenuParent(parent)
    // console.log("测试", menuList, current, parent);
  }, [menuList])

  const navTo = useCallback((e: any, item: NavType): void => {
    if (router.asPath == item.path) {
      return
    }
    e.stopPropagation();
    // if (item.path === '/audience/register') {
    //   setVisible(true)
    //   return
    // }
    if (item.out_link) {
      const a = document.createElement("a")
      a.href = `${item.out_link}`
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      return
    }
    router.push(item.path as any, item.path as any, {
      shallow: true
    })
  }, [menuCurrent])

  return (
    <div className={styles.page}>
      <div className={styles.banner}>
        <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src={banner} loading='lazy' alt="" />
        <div className={styles.title}>
          <div>
            <h1 style={{
              transform: router.locale === 'cn' ? 'translateY(-20px)' : 'translateY(-35px)'
            }}>{menuCurrent?.title}</h1>
            {
              menuParent?.childlist
              && menuParent.childlist.length > 1
              && !(router.locale === 'en' && router.asPath.includes('/event'))
              && (
                menuParent.childlist.length == 1 ? <h1>{menuParent?.childlist[0].title}</h1> : (
                  <ul className={cName([styles.pageNav])}>
                    {
                      menuParent?.childlist?.map(item => (

                        <li key={item.id} style={{
                          zIndex: '100',
                          background: item.id === menuCurrent?.id ?
                            '#6354a2'
                            : '',
                        }} onClick={(e) => navTo(e, item)}>
                          <span>{item.title}</span>
                        </li>
                      ))
                    }
                  </ul>
                )
              )
            }
          </div>

        </div>
      </div>
      <div className={styles.pageHeader}>
        <div className={styles.crumb}>
          <a href="/"><img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src="/image/home.png" alt="" /></a>
          <Breadcrumb
            compact={false}
            routes={
              [
                {
                  path: '/',
                  name: ''
                },
                {
                  path: menuCurrent?._href || menuParent?._href || '',
                  name: menuParent?.title || '',
                  isShow: !menuParent
                },
                {
                  path: menuCurrent?._href || '',
                  name: menuCurrent?.title || '',
                  isShow: !menuCurrent
                },
                ...crumb
              ].filter((item: any) => !item.isShow) as any
            }
            onClick={(item) => {
              router.push(item.path as any, item.path as any, {
                shallow: true
              })
            }
            }
            separator={'>'} />
        </div>
        <Swiper
          className={classNames([styles.swiper, 'minShow', 'mobileSwiper'])}
          modules={[]}
          spaceBetween={0}
          slidesPerView="auto"
          style={{ display: 'none' }}
        >
          {
            menuParent?.childlist
            && menuParent.childlist.length > 1
            && (
              menuParent.childlist.length == 1 ? <h1>{menuParent?.childlist[0].title}</h1> : (
                <div>
                  {
                    menuParent?.childlist?.map(item => (
                      <SwiperSlide key={item.id}>
                        <div
                          className={styles.swiperList}
                          style={{
                            zIndex: '100',
                            background: item.id === menuCurrent?.id ?
                              '#6354a2'
                              : '',
                            padding: '0 15px',
                            color: item.id === menuCurrent?.id ? 'white' : '#6354a2'
                          }} onClick={(e) => navTo(e, item)}>{item.title}</div>
                      </SwiperSlide>
                    ))
                  }
                </div>
              )
            )
          }

          <SwiperSlide></SwiperSlide>
        </Swiper>
      </div>
      <style jsx global>
        {
          `
          .mobileSwiper .swiper-slide{
            width:auto !important;
          }
          .semi-typography{
            font-size:20px;
          }
          .semi-breadcrumb-item-title .semi-typography{
            max-width: none !important;
            line-height: 1.5 !important;
          }
          `
        }
      </style>
    </div>
  );
};
